<template>
    <el-card class="box-card">
        <el-form :inline="true">
            <el-form-item label="模板名:">
                <el-input v-model="queryContent" placeholder="请输入模版名"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="queryTemplates()">查询模版</el-button>
                <el-button @click="showCreateTemplate()">创建模板</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="templateData" border style="margin-top:20px;width: 100%">
            <el-table-column  width="80px"  prop="id" label="模板ID"></el-table-column>
            <el-table-column  width="120px"  prop="templateType" label="模板类型">
                <template slot-scope="scope">
                    <span v-if="scope.row.templateType == 'common'">通用(common)</span>
                    <span v-else-if="scope.row.templateType == 'kefu'">客服(kefu)</span>
                </template>
            </el-table-column>
            <el-table-column width="200px" prop="templateName" label="模板名"></el-table-column>
            <el-table-column width="600px" prop="rewardsStr" label="奖励串"></el-table-column>
            <el-table-column width="180px" prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="warning" @click="showModifyTemplate(scope.row)">修改</el-button>
                    <el-button type="danger" @click="delTemplate(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 创建 -->
        <el-dialog title='模板内容' :visible.sync="showDialog" lock-scroll center>
            <el-card>
                <div slot="header" class="clearfix">
                    <span>模版编辑</span>
                </div>
                <el-input v-model="mailTemplateForm.templateName" placeholder="请填写模版名"></el-input>

                <el-select v-model="mailTemplateForm.templateType" placeholder='选择模板类型' style="margin-top: 20px;">
                    <el-option v-for="item in templateTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-card>

            <mail-editor :showTemplate="false" mailType="mail_template" :mailTemplateContent="mailTemplateContent" @mailContent="getMailContent" @rewardsStr="getRewardsStr" :mailTemplateRewardStr="mailTemplateRewards" :confirmSendMail="confirmSendMail" :templateType="mailTemplateForm.templateType"></mail-editor>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-if="dialogMode == 'mode-create'" @click="saveTemplate()">创建</el-button>
                <el-button type="primary" v-if="dialogMode == 'mode-modify'" @click="modifyTemplate()">修改</el-button>
                <el-button @click="showDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
    import mailTemplateApi from '../../service/mail_template_api';
    import commonEditor from '../../components/common_editor';
    import mailEditor from '../../components/mail_editor'
    import lang_config from '../../data/lang_config.json';
    import {
        mapState
    } from 'vuex';
    import actionConfirm from "../../mixins/action_confirm";

    export default {
        name: "mail_template_manager",
        data() {
            return {
                title: this.$route.meta.title,
                queryContent: "",
                isMulti: false,
                templateData: [],
                dialogMode: "",

                showDialog: false,
                langs: lang_config,

                langGroups: [],
                multiMail: [],

                mailTemplateForm: {
                    rewards: "",
                    contentMap: "",
                    templateName: "",
                    templateType: ""
                },

                templateTypeOptions: [
                    {
                        label: '通用',
                        value: 'common'
                    },
                    {
                        label: '客服',
                        value: 'kefu'
                    }
                ],

                // 邮件类型
                mailTemplateContent: {
                    'zh-Hans': {title: "", sender: "", content: [], contentHtml: ""},
                    'zh-Hant': {title: "", sender: "", content: [], contentHtml: ""},
                    'ja-JP': {title: "", sender: "", content: [], contentHtml: ""},
                    'ko-KR': {title: "", sender: "", content: [], contentHtml: ""},
                    'ru-RU': {title: "", sender: "", content: [], contentHtml: ""},
                    'en-US': {title: "", sender: "", content: [], contentHtml: ""}
                },
                modifyTemplateId: 0,

                mailTemplateRewards: '',

                confirmSendMail: false,

                optionMap:{
                    '0':this.$t("reward_editor.39"),
                    '1':this.$t("reward_editor.40"),
                    '2':this.$t("reward_editor.41"),
                    '3':this.$t("reward_editor.42"),
                    '4':this.$t("reward_editor.43"),
                    '5':'约束性道具',
                    '6':this.$t("reward_editor.44"),
                    '7':'战纹',
                    '8':this.$t("reward_editor.46"),
                    '9':this.$t("reward_editor.47"),
                    '10':'回复类道具',
                    '11':'头像',
                    '12':'头像框',
                    '13':'宝箱',
                    '14':'皮肤',
                    '15':'时效类道具',
                    '16':'部落头像',
                    '17':'起源盘',
                    '18':'自选元核',
                    '19':'进化光谱',
                    '20':'聊天框',
                    '21':'战斗框',
                    '22':'元核碎片',
                    '23':'元核髓',
                },
                optionValue: '0',
                count1: '',
                count2: '',
                countSwitch: false,
                rate: 0.1,
                value: '',
                emblemEntryConfigs: [],
                emblemLevel: 1,
                emblemStage: 0,
                emblemQuality: 1,
                emblemFate:0,
                emblemFateCustomizeTags:[],
                emblemFateCustomize:100,
                emblemMainProperty: 1,
                emblemFateProperty: 51,
                editEmblemEntries:[
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ],

                rewardsCN: '',
                rewardsCNId: '',
            }
        },

        mounted() {
            this.getLangs();
            this.queryTemplates();

        },
        created() {
        },
        computed: {
            ...mapState({
                // lang: state => state.user.userInfo.lang,
                token: state => state.user.userInfo.loginToken,
            }),
        },
        mixins: [actionConfirm],
        methods: {
            // 获取邮件内容编辑器信息
            getMailContent(val) {
                this.langGroups = val;
                this.mailTemplateForm.contentMap = val;
            },
            getRewardsStr(val) {
                this.mailTemplateForm.rewards = val;
            },

            showCreateTemplate() {
                let self = this;
                self.dialogMode = "mode-create";
                self.showDialog = true;
                self.mailTemplateContent = {
                    'zh-Hans': {title: "", sender: "", content: [], contentHtml: ""},
                    'zh-Hant': {title: "", sender: "", content: [], contentHtml: ""},
                    'ja-JP': {title: "", sender: "", content: [], contentHtml: ""},
                    'ko-KR': {title: "", sender: "", content: [], contentHtml: ""},
                    'ru-RU': {title: "", sender: "", content: [], contentHtml: ""},
                    'en-US': {title: "", sender: "", content: [], contentHtml: ""}
                };
                self.modifyTemplateId = 0;
                self.mailTemplateForm = {
                    rewards: "",
                    contentMap: "",
                    templateName: "",
                    templateType: ""
                };
                self.mailTemplateRewards = '';

            },
            showModifyTemplate(val) {
                let self = this;
                self.dialogMode = "mode-modify";
                self.showDialog = true;
                self.mailTemplateContent = val.contentMap;
                self.modifyTemplateId = val.id;
                self.mailTemplateForm.templateName = val.templateName;
                self.mailTemplateForm.templateType = val.templateType;
                self.mailTemplateRewards = val.rewards;
            },
            // 邮件模板列表
            queryTemplates() {
                let self = this;
                let queryForm = {
                    isMulti: self.isMulti,
                    queryContent: self.queryContent
                }

                mailTemplateApi.findByName({
                    queryForm: queryForm,
                    token: self.token
                }).then(res => {
                    self.templateData = res;
                    self.templateData.forEach(item => {
                        // item.rewards = item.rewards + (item.rewards?'(':'') + self.rewardsToCN(item.rewards) + (item.rewards?')':'');
                        item.rewardsStr = item.rewards + (item.rewards?'(':'') + self.rewardsToCN(item.rewards) + (item.rewards?')':'');
                    })
                })
            },

            // 创建邮件模板
            saveTemplate() {
                var self = this;
                this.confirmSendMail = true;
                setTimeout(() => {
                    this.confirmSendMail = false;
                    mailTemplateApi.saveTemplate({
                        mailTemplateForm: self.mailTemplateForm,
                        token: self.token
                    }).then(res => {
                        self.showDialog = false;
                        self.$message({
                            type: 'success',
                            message: '添加成功'
                        });
                        self.queryTemplates();
                    })
                },1000)


            },

            // 修改邮件模板
            modifyTemplate() {
                var self = this;
                this.confirmSendMail = true;
                setTimeout(() => {
                    this.confirmSendMail = false;

                    mailTemplateApi.modifyTemplate({
                        id: self.modifyTemplateId,
                        mailTemplateForm: self.mailTemplateForm,
                        token: self.token
                    }).then(res => {
                        self.showDialog = false;
                        self.$message({
                            type: 'success',
                            message: '修改成功'
                        });
                        self.queryTemplates();


                    })
                },1000)

            },
            // 删除邮件模板
            delTemplate(id) {
                let self = this;
                mailTemplateApi.delTemplate({
                    id: id,
                    token: self.token
                }).then(res => {
                    self.$message({
                        type: 'success',
                        message: '删除成功'
                    });
                    self.queryTemplates();
                })
            },
            changeItem(e) {
                let self = this;
                self.langGroups.forEach(item => {
                    let id = item.id;
                    let createFlag = true;
                    self.multiMail.forEach(mail => {
                        if (mail.id == id) {
                            createFlag = false;
                        }
                    })
                    if (createFlag) {
                        self.multiMail.push({
                            id: id,
                            title: "",
                            content: "",
                            sender: "",
                            rewards: ""
                        })
                    }
                })
            },
            getRewards(val) {
                this.mailTemplateForm.rewards = val;
            },

            rewardsToCN(rewards) {
                let arr = rewards.split(',');
                let result = '';
                arr.forEach(item => {
                    if (item !== '') {
                        this.resolveRewardStr(item);

                        let optionValueCN = this.optionMap[this.optionValue];
                        let idCn = this.getIdCn(this.optionValue,this.value);
                        let finalCount = '';
                        if (this.countSwitch) {
                            finalCount = this.count1 + "-" + this.count2;
                        } else {
                            finalCount = this.count1
                        }
                        let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                        result = result + (result?',':'') + finalContentCN;
                    }

                })

                return result;
            },

            resolveRewardStr(str){
                let self = this;

                if (str == '') {
                    self.countSwitch = false;
                    self.rateSwitch = false;
                    self.isDetail = false;
                    self.count1 = 1;
                    self.count2 = 1;
                    self.rate = 0.1;
                    self.emblemLevel = 1;
                    self.emblemStage = 0;
                    self.emblemQuality = 1;
                    self.emblemMainProperty = 1;
                    self.emblemFate = 0;
                    self.emblemFateCustomize = 100;
                    self.emblemFateProperty = 51;

                    self.editEmblemEntries = [
                        {
                            entry:[3, 0],
                            quality:0,
                            active:true
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                        {
                            entry:[3, 0],
                            quality:0,
                            active:false
                        },
                    ]
                }

                let rewardArray = str.toString().split("_");

                for (let index = 0; index < rewardArray.length; index++) {
                    const element = rewardArray[index];
                    switch (index) {
                        case 0:
                            let bigTypeArry = element.split("$");
                            //大类
                            self.optionValue = bigTypeArry[0];
                            //identify
                            self.value = parseInt(bigTypeArry[1]);
                            if (self.value == 50001) {
                                self.emblemRandomByQuality = false;
                            } else {
                                self.emblemRandomByQuality = true;
                            }
                            break;
                        case 1:
                            //数量
                            let countArry = element.split("-");
                            if(countArry.length>1){
                                self.countSwitch = true;
                                self.count1 = countArry[0];
                                let rateAndCount = countArry[1].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count2 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count2 = countArry[1];
                                }
                            }else{
                                self.countSwitch = false;

                                let rateAndCount = countArry[0].split('|');
                                if (rateAndCount.length>1) {
                                    self.rateSwitch = true;
                                    self.count1 = rateAndCount[0];
                                    self.rate = rateAndCount[1];
                                } else {
                                    self.rateSwitch = false;
                                    self.count1 = countArry[0];
                                }
                            }
                            break;
                        case 2:
                            //等级
                            self.emblemLevel = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveQuality = parseInt(element);
                            }
                            break;
                        case 3:
                            //阶段
                            self.emblemStage = parseInt(element);

                            if (self.optionValue == '7') {
                                if (element) {
                                    self.warGrooveChannelSwitch = true;
                                    self.warGrooveChannelUp = parseInt(element);
                                } else {
                                    self.warGrooveChannelSwitch = false;
                                }
                            }
                            break;
                        case 4:
                            //品质
                            self.emblemQuality = parseInt(element);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelDown = parseInt(element);
                            }
                            break;
                        case 5:
                            //宿命
                            let fateArray = element.split("#");
                            self.emblemFate = 3;
                            if(fateArray.length>1){
                                for (let i = 0; i < fateArray.length; i++) {
                                    const element = fateArray[i];
                                    let item = fateArray.splice("@");
                                    self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                                }
                            }else{
                                if(element>0){
                                    self.emblemFate = 2;
                                    self.emblemFateProperty = parseInt(element);
                                }else{
                                    self.emblemFate = 0;
                                }
                            }

                            if (self.optionValue == '7') {
                                self.warGrooveChannelLeft = parseInt(element);
                            }

                            break;
                        case 6:
                            //宿命自定义概率
                            self.emblemFateCustomize = parseInt(element*100);

                            if (self.optionValue == '7') {
                                self.warGrooveChannelRight = parseInt(element);
                            }
                            break;
                        case 7:
                            //主属性
                            self.emblemMainProperty = parseInt(element);
                            break;
                        case 8:
                            //词条属性
                            let entryArray = element.split("#");
                            for (let index = 0; index < entryArray.length; index++) {
                                const entryItem = entryArray[index];
                                let current = self.editEmblemEntries[index];

                                self.emblemEntryConfigs.forEach(item => {
                                    item.children.forEach(iitem => {
                                        if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                            self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                            self.editEmblemEntries[index].active = true;
                                        } else {
                                            self.editEmblemEntries[index].active = false;
                                        }
                                    })
                                })

                                self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                            }

                            let countAndEntry = entryArray[entryArray.length-1].split('|');
                            if (countAndEntry.length>1) {
                                self.rateSwitch = true;
                                self.rate = countAndEntry[1];
                            } else {
                                self.rateSwitch = false;
                            }
                            break;
                        default:
                            break;
                    }
                }
            },

            getIdCn(optionValue,id){
                let self = this;
                if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" || optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15"){
                    //道具
                    return self.$t('propConfigName_'+id);
                }else if(optionValue == "1"){
                    //怪兽
                    return self.$t('monsterName_' + id);
                }else if(optionValue == "2"){
                    //怪兽碎片
                    return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
                }else if(optionValue == "6"){
                    //怪兽觉醒水晶
                    return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
                }else if(optionValue == "8"){
                    //怪兽觉醒水晶碎片
                    return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
                }else if(optionValue == "7"){
                    //战纹
                    return self.$t('warGrooveConfigName_' + id);
                }
            },
        },
        components: {
            commonEditor,
            mailEditor
        }
    }
</script>

<style scoped lang="less">
    .el-card {
        margin: 5px 0 !important;
    }

    .reward-text {
        color: #5daf34;
    }
</style>



// WEBPACK FOOTER //
// src/views/mails/mail_template.vue